import React, { useEffect, useRef, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { Container, Col, Card, CardBody, Nav, NavItem } from "reactstrap";
import { getRolesForTables } from "../../slices/admin/thunk";
import classnames from "classnames";
import {
  addOwnRoleNational,
  downloadBrokersReport,
  getOwnRoleNational,
} from "../../slices/national/thunk";
import { useDispatch } from "react-redux";
import Loading from "../../Components/Loading";
import Swal from "sweetalert2";
import BrokersTable from "../../Components/Tables/BrokerTable/BrokersTable";
import { useCurrentUser } from "../../slices/auth/hooks";
import AddRoleModal from "../../Components/modals/GeneralModals/AddRoleModal";
import SearchBar from "../../Components/SearchBar/SearchBar";
import ButtonAddRole from "../../Components/Buttons/ButtonAddRole";
import HeadersRole from "../../Components/Headers/HeadersRole";
import brokerIcon from "../../assets/images/iconsRoles/brokerIcon.svg";
import DownloadReportCSVButton from "../../Components/Buttons/DownloadReportCSVButton";
import DropdownActionsTable from "../../Components/Dropdown/DropdownActionsTable";
import CopyInviteLink from "../../Components/Buttons/CopyInviteLinkButton";
import { DASHBOARD_USER_ROLES } from "../../constants";

const DashboardNationalsBrokers = () => {
  const currentUser = useCurrentUser();
  const inputRef = useRef(null);
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [brokers, setBrokers] = useState([]);
  const [totalBrokers, setTotalBrokers] = useState(0);
  const [pageSize, setPageSize] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const [currentPage, setCurrentPage] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");

  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(searchTerm);
  const [searchDone, setSearchDone] = useState(false);
  const [lastSearchTerm, setLastSearchTerm] = useState(searchTerm);

  const [openModalAddBroker, setOpenModalAddBroker] = useState(false);

  const handleToggleModalAddBroker = () => {
    setOpenModalAddBroker(!openModalAddBroker);
  };

  const [ownBrokers, setOwnBrokers] = useState(false);

  const [activeTab, setActiveTab] = useState("1");

  const toggleTab = (tab, status) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setOwnBrokers(status === "own");
      setCurrentPage(0);
    }
  };

  useEffect(() => {
    const timerId = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500);

    return () => clearTimeout(timerId);
  }, [searchTerm]);

  const fetchRolesNational = async () => {
    try {
      setLoading(true);
      const response = await dispatch(
        getRolesForTables({
          id: currentUser.id,
          userRole: "nationals",
          role: "brokers",
          page: currentPage,
          query: searchTerm,
        })
      ).unwrap();
      setBrokers(response.data);
      setTotalBrokers(response.total);
      setPageSize(response.pageSize);
      setTotalPages(response.pages);
      setSearchDone(true);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (debouncedSearchTerm === lastSearchTerm) {
      setSearchDone(true);
    } else {
      setSearchDone(false);
    }
    if (activeTab == "1") {
      fetchRolesNational();
    } else {
      getOwnBrokers();
    }
  }, [currentPage, debouncedSearchTerm, dispatch, ownBrokers]);

  const handleChangePage = (page) => {
    setCurrentPage(page);
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
  };

  const getOwnBrokers = async () => {
    try {
      setLoading(true);
      const response = await dispatch(
        getOwnRoleNational({
          id: currentUser.id,
          role: "brokers",
          page: currentPage,
          query: searchTerm,
        })
      ).unwrap();

      console.log(response);
      setBrokers(response.data);
      setTotalBrokers(response.total);
      setPageSize(response.pageSize);
      setTotalPages(response.pages);
      setSearchDone(true);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleAddOwnBroker = async (data) => {
    try {
      setLoading(true);
      const response = await dispatch(
        addOwnRoleNational({
          id: currentUser.id,
          role: "brokers",
          data,
        })
      ).unwrap();
      console.log(response);
      setLoading(false);
      if (response.error) {
        Swal.fire({
          title: "Error",
          text: response.error,
          icon: "error",
          confirmButtonText: "Ok",
        });
        return;
      }
      Swal.fire({
        title: "Success",
        text: "Broker added successfully",
        icon: "success",
        confirmButtonText: "Ok",
      });
      setActiveTab("2");
      setOpenModalAddBroker(false);
      getOwnBrokers();
    } catch (error) {
      console.log(error);
      setLoading(false);
      Swal.fire({
        title: "Error",
        text: "Error adding broker",
        icon: "error",
        confirmButtonText: "Ok",
      });
    }
  };

  return (
    <React.Fragment>
      <AddRoleModal
        open={openModalAddBroker}
        setOpen={setOpenModalAddBroker}
        onCreate={handleAddOwnBroker}
        loading={loading}
        roleToAdd="broker"
      />
      <div className="page-content px-0 ">
        <Container fluid>
          <HeadersRole role={"Brokers"} icon={brokerIcon} svg={true} />
          <Card className="mb-4 pb-3">
            <CardBody>
              <div className="col-12 d-flex justify-content-between mt-1  align-items-center ">
                <div className="col-4 d-flex justify-content-end align-items-center">
                  <SearchBar
                    inputRef={inputRef}
                    value={searchTerm}
                    onChange={handleSearch}
                    placeholder="Filter by name or email"
                  />

                  <DropdownActionsTable
                    downloadMethod={downloadBrokersReport}
                    params={{ nationalId: currentUser.id, role: "brokers" }}
                  />
                </div>
              </div>

              <Col xl={12}>
                <div className="d-flex align-items-start justify-content-between mb-3">
                  <Nav
                    className="nav-tabs-custom p-2 mb-2 card-header-tabs border-bottom-0 mt-0 "
                    role="tablist"
                  >
                    <NavItem className="me-3">
                      <NavLink
                        className={classnames(
                          {
                            "active  p-2 text-primary": activeTab === "1",
                            "fw-semibold": activeTab === "1",
                          },
                          {
                            "border-bottom border-2 border-primary":
                              activeTab === "1",
                          },
                          { " p-2 text-primary": activeTab !== "1" },
                          { disabled: loading }
                        )}
                        onClick={(e) => {
                          if (!loading) {
                            toggleTab("1", "all");
                          } else {
                            e.preventDefault();
                          }
                        }}
                        href="#"
                      >
                        ALL
                      </NavLink>
                      <NavLink
                        className={classnames(
                          {
                            "active  p-2 text-primary": activeTab === "2",
                            "fw-semibold": activeTab === "2",
                          },
                          {
                            "border-bottom border-2 border-primary":
                              activeTab === "2",
                          },
                          { " p-2 text-primary": activeTab !== "2" },
                          { disabled: loading }
                        )}
                        onClick={(e) => {
                          if (!loading) {
                            toggleTab("2", "own");
                          } else {
                            e.preventDefault();
                          }
                        }}
                        href="#"
                      >
                        MY BROKERS
                      </NavLink>
                    </NavItem>
                  </Nav>

                  <div className="col-4 d-flex justify-content-end align-items-center">

                    <CopyInviteLink role={DASHBOARD_USER_ROLES.BROKER} inviteCode={currentUser.inviteCode} />


                    <ButtonAddRole
                      open={handleToggleModalAddBroker}
                      roleToAdd="Broker"
                    />


                    {/* <DownloadReportCSVButton
                      downloadMethod={downloadBrokersReport}
                      params={{ nationalId: currentUser.id, role: "brokers" }}
                    /> */}
                  </div>
                </div>
                <div className="table-container  position-relative">
                  {loading && <Loading />}
                  <div className="live-preview">
                    <div className="table-responsive ">
                      <BrokersTable
                        data={brokers}
                        searchDone={searchDone}
                        searchParam={debouncedSearchTerm}
                        paginationProps={{
                          currentPage,
                          totalPages,
                          totalItems: totalBrokers,
                          pageSize,
                          onChangePage: handleChangePage,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </Col>
            </CardBody>
          </Card>
        </Container>
      </div>
      <div id="portal-root"></div>
    </React.Fragment>
  );
};

export default DashboardNationalsBrokers;
